import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosPrivate from "../../api/axiosPrivate";
import axiosPublic from "../../api/axiosPublic";

export const cableSubscriptions = createAsyncThunk(
  "cableSubscriptions",
  async (cable_tv_type, { rejectWithValue }) => {
    try {
      const { data } = await axiosPrivate.get(`transactions/get-subscriptions?cableTvType=${cable_tv_type}`);

      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
